import { useSuppliersStore } from "@/shared/stores/suppliersStore";
import { useEffect } from "react";

export function useSuppliers() {
  const { suppliers, loading, error, fetchSuppliers } = useSuppliersStore();

  useEffect(() => {
    fetchSuppliers();
  }, [fetchSuppliers]);

  return {
    suppliers,
    loading,
    isFetching: loading,
    error,
    refetch: fetchSuppliers,
  };
}
